import { render, staticRenderFns } from "./ModifyClub.vue?vue&type=template&id=353c7653&scoped=true"
import script from "./ModifyClub.vue?vue&type=script&lang=js"
export * from "./ModifyClub.vue?vue&type=script&lang=js"
import style0 from "./ModifyClub.vue?vue&type=style&index=0&id=353c7653&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353c7653",
  null
  
)

export default component.exports